import {isTablet} from './mobile-detect.js';

const initHeader = () => {
  const header = document.querySelector("header");
  const body = document.querySelector("body");
  const target = document.querySelector("#header-observer");
  const footer = document.querySelector("footer");

  // Add "small" class to header when observer is scrolled out of view
  if (header && target) {
    const observer = new IntersectionObserver(
      (entries, _observer) => {
        let on = !entries[0].isIntersecting;
        header.classList.toggle("small", on);
        body.classList.toggle("scrolled", on);
      },
      {
        rootMargin: "0px",
      },
    );
    if (target) observer.observe(target);
  }

  // Detect far scroll-down
  const footerObserver = new IntersectionObserver(
    (entries, _observer) => {
      let on = entries[0].isIntersecting;
      body.classList.toggle("scrolled-to-footer", on);
    },
    {
      rootMargin: "0px",
    },
  );
  if (footer) footerObserver.observe(footer);

  // On mobile, hide header while scrolling down, but show it again while scrolling up
  let lastScrollTop = window.pageYOffset
  const minimalScrollDown = 350
  const sensitivity = 200
  document.addEventListener("scroll", function(_event) {
    if (!isTablet()) { return; }
    const st = window.pageYOffset
    const diff = Math.abs(lastScrollTop - st);
    if (diff >= sensitivity) {
      // scrolled far enough
      header.classList.toggle("scroll-hide", st > minimalScrollDown && st > lastScrollTop);
      lastScrollTop = st
    }
  });
};

export default initHeader;
